import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { LocalizedText } from '@shared-ui/localization-context';

import { UitkButton } from 'uitk-react-button';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';

const ButtonTracked = ClickTracker(UitkButton);

export const CloseFormButton = ({ onClick }: { onClick: () => void }) => (
  <UitkLayoutFlex justifyContent="center">
    <UitkSpacing padding={{ blockend: 'four', blockstart: 'four' }}>
      <ButtonTracked
        linkName="Close search form"
        onClick={onClick}
        align="center"
        className="uitk-button-tertiary"
        data-stid="close-search-form"
        rfrr={':CloseSearch'}
      >
        <LocalizedText message="hotels.searchResults.close.text" />
      </ButtonTracked>
    </UitkSpacing>
  </UitkLayoutFlex>
);
